import * as grid from 'view/styles/grid';

const DATE_PICKER_WIDTH = grid.multiple(20).px;

export const datePickerStyles = {
    style: { width: DATE_PICKER_WIDTH },
};
